<template>
  <div class="list row">
    <h2>Tipovi vozila</h2>
    <div class="actions d-flex flex-row-reverse">
      <button
        type="button"
        class="btn btn-primary bi bi-arrow-clockwise"
        @click="refreshData"
      />
      <button
        type="button"
        class="btn btn-success bi bi-plus"
        @click="addData"
      />
    </div>
    <data-table
      url="vehicle-type"
      :columns="columns"
      :templates="templates"
      :headings="headers"
      :actions="actions"
      ref="datatable"
      @yes="deleteData"
      name="VehicleType"
    >
    </data-table>
  </div>
</template>

<script>
import VehicleTypeDataService from "../../services/vehicle-type.service";
import DataTable from "../widgets/DataTable.vue";
import VehicleTypeForm from "./VehicleTypeForm.vue";

export default {
  name: "vehicle-type",
  components: {
    DataTable,
  },
  data() {
    return {
      columns: ["name", "edit"],
      headers: {
        name: "Naziv",
        edit: "",
      },
      templates: {},
      actions: {
        edit: { commp: VehicleTypeForm },
        delete: {
          deleteData: this.deleteData,
          color: "danger",
          icon: "bi-trash",
        },
      },
      currentTutorial: null,
      currentIndex: -1,
      title: "",
    };
  },
  methods: {
    refreshData() {
      this.$refs.datatable.onRefresh();
    },
    addData() {
      this.$store.commit("app/showModal", {
        modal: VehicleTypeForm,
        params: { data: {}, title: "Dodaj novi tip vozila" },
      });
    },
    deleteData(id) {
      VehicleTypeDataService.delete(id)
        .then((response) => {
          this.$store.commit("app/showAlert", {
            type: "success",
            message: response.data.message,
          });
          this.$store.commit("app/hideModal");
        })
        .catch((e) => {
          console.log(e);
          this.$store.commit("app/showAlert", {
            type: "danger",
            message: e,
          });
        });
    },
  },
};
</script>

<style scoped>
.list {
  text-align: left;
  margin: auto;
}
</style>
